import React, { Fragment, useState } from "react";
import { NavLink, useRouteMatch, useLocation } from "react-router-dom";

type SubItem = {
  title: string;
  path: string;
};

type TabProps = {
  id: any;
  path: string;
  icon: any;
  title: any;
  activeTab: string;
  onClick?: any;
  useRouteMatch?: boolean;
  subItems?: SubItem[];
};

const Tab = (props: TabProps) => {
  const { url } = useRouteMatch();
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);

  // Check if any sub-item is active
  const isSubItemActive = props.subItems?.some(sub => location.pathname === sub.path);
  const isActive = props.activeTab.toLowerCase() === props.title.toLowerCase() || isSubItemActive;

  // Auto-expand if a sub-item is active
  const showSubItems = expanded || isSubItemActive;

  const handleClick = (e: React.MouseEvent) => {
    if (props.subItems && props.subItems.length > 0) {
      e.preventDefault();
      setExpanded(!expanded);
    }
  };

  return (
    <Fragment>
      <li
        key={props.id}
        id={props.id}
        className={`item ${isActive ? "active" : ""} ${props.subItems ? "has-subitems" : ""}`}
      >
        {props.useRouteMatch ? (
          <NavLink
            to={`${url.slice(0, url.lastIndexOf("/"))}/${props.path}`}
            className="tab-link"
            onClick={props.subItems ? handleClick : undefined}
          >
            <div className="tab-icon">{props.icon}</div>
            <div className="tab-label">{props.title}</div>
            {props.subItems && (
              <div className={`tab-arrow ${showSubItems ? "expanded" : ""}`}>▾</div>
            )}
          </NavLink>
        ) : (
          <NavLink
            to={props.path}
            className="tab-link"
            onClick={props.subItems ? handleClick : undefined}
          >
            <div className="tab-icon">{props.icon}</div>
            <div className="tab-label">{props.title}</div>
            {props.subItems && (
              <div className={`tab-arrow ${showSubItems ? "expanded" : ""}`}>▾</div>
            )}
          </NavLink>
        )}
      </li>
      {/* Sub-items */}
      {props.subItems && showSubItems && (
        <ul className="sub-items">
          {props.subItems.map((sub, idx) => (
            <li key={idx} className={`sub-item ${location.pathname === sub.path ? "active" : ""}`}>
              <NavLink to={sub.path} className="sub-link">
                {sub.title}
              </NavLink>
            </li>
          ))}
        </ul>
      )}
    </Fragment>
  );
};

export default Tab;
